import styled, { css } from 'styled-components';
import { colors, layout, remCalc } from '@prisjakt/ui-base';

type CheckboxProps = { disabled?: boolean };
export const Checkbox = styled.div<CheckboxProps>`
  user-select: none;
  font-weight: normal;
  opacity: ${props => (props.disabled ? '0.5' : '1')};
`;

export const Label = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  position: relative;
`;

export const Input = styled.input`
  appearance: none;
  outline: 0;
  opacity: 0;
  position: absolute;
`;

type CheckIconWrapperProps = {
  checked?: boolean;
  partial?: boolean;
};
export const CheckIconWrapper = styled.span<CheckIconWrapperProps>`
  display: flex;
  border: 1px solid ${p => p.theme.lines.secondary};

  ${Input}:focus + & {
    border-color: ${colors.lightBlue3};
    outline: 1px solid ${colors.lightBlue3};
  }

  svg {
    position: relative;
    left: 1px;
    top: 1px;
    stroke-width: 6px;
    path {
      stroke: ${colors.white};
    }
  }

  ${props =>
    props.checked || props.partial
      ? css`
          background-color: ${colors.lightBlue1};
          border-color: ${colors.lightBlue1};
          outline: 1px solid ${colors.lightBlue1};
          svg {
            background-color: ${colors.lightBlue1};
          }
          ${Input}:focus + & {
            background-color: ${colors.lightBlue3};
            border-color: ${colors.lightBlue3};
            outline: 2px solid ${colors.lightBlue3};
            svg {
              background-color: ${colors.lightBlue3};
            }
          }
        `
      : null};
`;

export const LabelText = styled.span`
  margin-left: ${layout.listSideMargin};
  display: flex;
  flex-direction: column;
  color: ${colors.darkGray4};
`;

type HelperProps = { warning?: boolean };
export const Helper = styled.span<HelperProps>`
  font-size: ${remCalc(12)};
  color: ${props => (props.warning ? colors.red1 : colors.darkGray1)};
  width: 100%;
`;
